/** Require explicit permission and the existing production host allowlist. */
export const shouldEnableSentry = (
  disableFlag: string | undefined,
  hostname: string,
): boolean =>
  disableFlag === "false" &&
  (hostname === "drawola.com" ||
    hostname.endsWith(".drawola.com") ||
    hostname.endsWith(".drawola.pages.dev"));

export const isSentryEnabled = shouldEnableSentry(
  import.meta.env.VITE_APP_DISABLE_SENTRY,
  window.location.hostname,
);
